/* global axios */
import ApiClient from './ApiClient';

class VisitorsAPI extends ApiClient {
  constructor() {
    super('visitors', { accountScoped: true });
  }

  get(page = 1, perPage = 25) {
    return axios.get(this.url, { params: { page, per_page: perPage } });
  }
}

export default new VisitorsAPI();
